import  { useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Link, useParams } from 'react-router-dom';
import { toast } from 'react-toastify';
import { getAsync, postAsync } from '../../../../../components/helper/axiosHelper';
import Card from 'react-bootstrap/Card';
import LoadingAnimation from '../../../../../components/LoadingAnimation';
import { DataNotFound } from '../../../../../components/DataNotFound';
import { defaultImage } from '../../../../../constants';

const CampaignList = () => {
  const { referralLink, pid } = useParams();
  const [campaignName, setCampaignName] = useState('');
  const [projectApiData, setProjectAPIData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [datanotfound, setDatanotfound] = useState(false);
  const { t } = useTranslation();
  const hasMounted = useRef(false);

  useEffect(() => {
    if (!hasMounted.current) {
      hitCount();
      getProject();
      getCampaign();
      hasMounted.current = true;
    }
  }, []);

  const getCampaign = async () => {
    await getAsync('Campaign/GetCampaignByCampaignLink/', { referralLink: referralLink })
      .then((response) => {
        setCampaignName(response?.data[0]?.campaignName);
      })
      .catch((error) => {
        toast.error(t('Something went wrong, Please try again!'));
      });
  };

  const getProject = async () => {
    setIsLoading(true);
    await getAsync(`TempProject/GetProjectListByReferralLinkAsync/${referralLink}/${2}`)
      .then((response) => {
        setIsLoading(false);
        setProjectAPIData(response?.data);
        if (response?.statusCode == 204) {
          setDatanotfound(true);
        }
      })
      .catch((error) => {
        toast.error(t('Something went wrong, Please try again!'));
      });
  };

  const hitCount = async () => {
    await postAsync('Utilities/ViewHitAPI', {}, { processID: pid, projectID: referralLink })
      .then((response) => {
        const result = response?.data;
      })
      .catch((err) => {
        console.log(err);
        toast.error(t('Something went wrong, Please try again!'));
      });
  };

  return (
    <>
      <>
        <div className="container-fluid lg:px-5 pb-10 bg-slate-50">
          <div className="row">
            <div className="col-lg-12 pt-20 lg:pt-40">
              <h1 className="font-bold sm:text-4xl text-customgreen text-xl mt-3" style={{ textAlign: 'center' }}>
                {campaignName} {t('Projects')}
              </h1>
            </div>
          </div>
          <div className="row">
            {isLoading ? (
              <LoadingAnimation />
            ) : (
              projectApiData?.map((data, index) => (
                <>
                  <div key={index} className="col-sm-6 mt-4 col-md-4 col-lg-3">
                    <Card
                      style={{
                        cursor: 'pointer',
                      }}
                      className="shadow-full p-3 mx-2 bg-white rounded-3xl flex items-center justify-center"
                    >
                      <Card.Body>
                        <Card.Title className="capitalize font-semibold text-customgreen">
                          {data?.templateName}
                        </Card.Title>
                        {/* <Card.Text>{data?.projectID}</Card.Text> */}
                      </Card.Body>
                      <div className=" rounded-md">
                        {data.file_Stream ? (
                          <>
                            <img
                              className="lg:mb-20 mb-4 w-96 xl:w-96 h-32 rounded-t-3xl"
                              src={`data:image/jpeg;base64,${data?.file_Stream}`}
                            />
                          </>
                        ) : (
                          <>
                            <img
                              className="lg:mb-20 mb-4  rounded-t-3xl"
                              src={`data:image/jpeg;base64,${defaultImage}`}
                            />
                          </>
                        )}
                      </div>
                      <Link
                        to={`/PaymentProcess/${data?.id}/${data?.referralLink}/${3}/${data?.projectTypeIdInt}`}
                        className="text-white mx-1 w-4/5 bg-customgreen hover:bg-hovergreen focus:outline-none focus:ring-4 focus:ring-customgreen font-medium rounded-full text-sm px-5 py-2.5 text-center"
                      >
                        {t('Select')}
                      </Link>
                      {/* <button className="btn btn-success">{t('Select')}</button> */}
                    </Card>
                  </div>
                </>
              ))
            )}
            {datanotfound && <DataNotFound />}
          </div>
        </div>
     
      </>
    </>
  );
};

export default CampaignList;
